import { Spinner } from '../constants';

export function spinnerOn(ref) {
  const element = ref?.current;

  if (element) {
    document.body.style.overflow = 'hidden';
    element.classList.remove(Spinner.invisibleClass);
  }
}

export function spinnerOff(ref) {
  const element = ref?.current;

  if (element) {
    document.body.style.overflow = 'visible';
    element.classList.add(Spinner.invisibleClass);
  }
}
